import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const { authData } = useSelector((state) => state.loginSlice);

  return authData ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
